<script>
import { Button } from 'ant-design-vue';

export default {
  emits: ['onClick'],
  components: { ButtonComp: Button },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    shape: {
      type: String,
      default: 'default',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    icon: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'default',
    },
    danger: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <ButtonComp
    :id="id"
    :shape="shape"
    :type="variant"
    :loading="loading"
    :disabled="disabled"
    :icon="icon"
    :size="size"
    :danger="danger"
    @click="(event) => $emit('onClick', event)"
  >
    <slot></slot>
  </ButtonComp>
</template>

<style lang="scss" scoped></style>
